import type React from 'react'
import type { PropsWithChildren } from 'react'

import { cn } from '@/utils/shadcn/utils'

interface ContainerProps extends PropsWithChildren {
  className?: string
  label?: string
  value?: string | number
}

export const DistributionsContainer = ({ children }: ContainerProps) => (
  <div className="@container/distributions">{children}</div>
)

export const DistributionsHeader: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="mt-[24px] mb-[12px]">{children}</div>

export const DistributionsText: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="text-[15px] font-medium">{children}</div>

export const DistributionsGrid: React.FC<ContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={cn(
      'grid grid-cols-2 @max-[928px]:grid-cols-1 gap-4 mb-6',
      className,
    )}
  >
    {children}
  </div>
)

export const DistributionsCard = ({ children, className }: ContainerProps) => {
  const baseHeight = 20 + 112 + 4 // padding-y + chart + buffer = 136px
  return (
    <div
      className={cn(
        'bg-background border border-primary-border px-4 pt-3 pb-2 mt-0 rounded-lg',
        className,
      )}
      style={{
        minHeight: baseHeight,
      }}
    >
      {children}
    </div>
  )
}
